import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid text-center p-10 py-lg-15" }
const _hoisted_3 = { class: "pt-lg-10 mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder fs-4x text-gray-800 mb-10" }, "Acesso Negado", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-3 text-muted mb-15" }, [
  /*#__PURE__*/_createTextVNode(" Você não tem permissão para acessar esta página. "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-100px min-h-lg-350px",
  style: {"background-image":"url('media/illustrations/sketchy-1/17.png')"}
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-center flex-column-auto p-10" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToHome && _ctx.goToHome(...args))),
            class: "btn btn-lg btn-danger fw-bolder"
          }, " Volte para Homepage ")
        ])
      ]),
      _hoisted_7
    ]),
    _hoisted_8
  ]))
}